/**
 * Ordinal féminin français, forme courte : 1re, 2e, 3e…
 * Destiné aux libellés du type « 2e formation sur 3 ».
 */
export function frenchFeminineOrdinal(n: number): string {
  if (n === 1) return '1re'
  return `${n}e`
}
